/**
 * Created by alex.y on 7/19/2017.
 */

import {Injectable} from "@angular/core";
import {BaseApi} from "./baseService";
import {BaseResponse} from "../objects/common/baseResponse";
import {CurrencyItem} from "../objects/currencyExchange/currencyItem";
import {RequestOptions} from "@angular/http";
import {CanadianCurrencyCode} from "../objects/currencyExchange/canadianCurrencyCode";

@Injectable()
export class CurrencyService extends BaseApi {

    public getFromDate(dateFrom: Date): Promise<BaseResponse<Array<CurrencyItem>>> {

        return this.get(new RequestOptions({
            url: `currency`,
            params: { dateFrom: (String.formatDateMMDDYYYY(dateFrom.toString())) }
        }));
    }

    public getCanadianCurrencyCodes(): Promise<BaseResponse<CanadianCurrencyCode[]>> {
        return this.get(new RequestOptions({
            url: `currency/codes/canadian`
        }));
    }

}


// WEBPACK FOOTER //
// ./app/services/currencyService.ts